module.exports = __webpack_public_path__ + "static/media/NA-Host-Reseller.45f998bd.png";